export const APP_VERSION = {
    name: 'Le Guetteur Yoga',
    version: '1.2.0' // !! Penser à modifier la version dans index.html !!!
};
export const API_URL_DEV = 'http://guetteuryoga.localhost/back/api/';
// HOSTINGER
// export const api_url_prod = readable('https://collectifapi.yvanpoirier.fr/back/api/');
// OVH DNS Ancien
// export const api_url_prod = readable('http://knpnjql.cluster029.hosting.ovh.net/back/api/');
// OVH domaine
export const API_URL_PROD = 'https://leguetteuryoga.fr/back/api/';
// OVH DNS Ancien
// export const API_URL_PROD = 'http://kzjckys.cluster100.hosting.ovh.net/back/api/';
export const REDIRECTION_REDIRECT = 'redirect';
export const PODCAST_CATEGORY_1 = { id: "1", label: "Le yoga et son monde", texte: "Le yoga par ceux qui le font, le transmettent, le recréent" };
export const PODCAST_CATEGORY_2 = { id: "2", label: "Le yoga et vous", texte: "On l'aime, on le quitte, on y revient. Il nous fascine ou nous agace, nous transforme ou nous ennuie. Parole aux pratiquants, ceux d'un jour, ceux de toujours " };
export const PODCAST_CATEGORY_3 = { id: "3", label: "Le yoga...et plus si affinités", texte: "Au-delà du tapis, le yoga inspire le quotidien, le travail, l'amour, diffuse dans les interstices proches ou lointains de nos aventures. Tour du jour et tour du monde en tenue de yoga" };
